import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { isOnline } from '../../components/form/utils';
import { updateOnlineStatus } from '../../components/form/reducer/form';

export const useFormNetwork = (inForm = false, formSubmitted = false, submitError = false) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (inForm && !formSubmitted && !submitError) {
      const intervalID = setInterval(async () => {
        const online = await isOnline();
        dispatch(updateOnlineStatus({ online }));
      }, 5000);
      return () => clearInterval(intervalID);
    }
  }, [inForm, formSubmitted, submitError]);
};

export default useFormNetwork;
